<div #dateDropdown='ngbDropdown'
  (openChange)="emit(dropdown.isOpen())"
  autoClose="outside"
  class="filter-dropdown"
  ngbDropdown>
  <app-tooltip [dynamic]="false"
    class="display-inline-flex"
    message="Filter">
    <button [attr.data-cy]="getCypressTagElement('icon')"
      [ngClass]="getCssButton()"
      class="filter filter-icon iwp-icon-gen_filter"
      ngbDropdownToggle
      tabIndex="-1"
    type="button"></button>
  </app-tooltip>
  <form [attr.data-cy]="getCypressTagElement('dropdown')"
    [formGroup]="selectedDateFilter"
    class="filter-menu"
    ngbDropdownMenu
    placement="'bottom-right'">
    <div [attr.data-cy]="getCypressTagElement('dropdown-option')"
      class="filter-option no-hover filter-date-datepicker"
      ngbDropdownItem>
      <input #pickDate
        (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="getCypressTagElement('dropdown-option-pickDate')"
        [value]="DateFilterOptions.PICKDATE"
        class="radio-button"
        formControlName="selectedDate"
        id="{{filterName}}-pickDate"
        name="selectedDate"
        type="radio">
      <div class="text-radio-input">
        <app-input-date #pickDateInput
          (inputFocus)="onDateFocus()"
          (inputValueChange)="onDateChange($event)"
          [alternateBackground]="true"
          [baseCypressTag]="getCypressTagElement('dropdown-option-pick-date')"
          [isSmallLabel]="true"
        placeholder="Pick Date"></app-input-date>
      </div>
    </div>
    <div class="filter-option filter-item"
      ngbDropdownItem>
      <input #allDates
        (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-filter-dropdown-option-all'"
        [checked]="true"
        [value]="DateFilterOptions.ALL"
        formControlName="selectedDate"
        id="{{filterName}}-all"
        name="selectedDate"
        type="radio">
      <label [attr.data-cy]="filterName + '-filter-all-label'"
        class="filter-option-label"
      for="{{filterName}}-all">All</label>
    </div>

    <div class="separator"></div>
    @if (hasEmptyOption) {
      <div
        class="filter-option filter-item"
        ngbDropdownItem>
        <input (keydown.enter)="closeAndSearch()"
          [attr.data-cy]="filterName + '-filter-dropdown-option-empty'"
          [value]="DateFilterOptions.EMPTY"
          formControlName="selectedDate"
          id="{{filterName}}-empty"
          name="selectedDate"
          type="radio">
        <label [attr.data-cy]="filterName + '-filter-empty-label'"
          class="filter-option-label"
        for="{{filterName}}-empty">Empty</label>
      </div>
    }

    <div class="filter-option filter-item"
      ngbDropdownItem>
      <input (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-filter-dropdown-option-pastDay'"
        [value]="DateFilterOptions.PASTDAY"
        formControlName="selectedDate"
        id="{{filterName}}-pastDay"
        name="selectedDate"
        type="radio">
      <label class="filter-option-label"
      for="{{filterName}}-pastDay">Past 24 hours</label>
    </div>

    <div class="filter-option filter-item"
      ngbDropdownItem>
      <input (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-filter-dropdown-option-pastWeek'"
        [value]="DateFilterOptions.PASTWEEK"
        formControlName="selectedDate"
        id="{{filterName}}-pastWeek"
        name="selectedDate"
        type="radio">
      <label class="filter-option-label"
      for="{{filterName}}-pastWeek">Past week</label>
    </div>

    <div class="separator"></div>
    <div class="filter-option filter-item"
      ngbDropdownItem>
      <input (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-filter-dropdown-option-pastMonth'"
        [value]="DateFilterOptions.PASTMONTH"
        formControlName="selectedDate"
        id="{{filterName}}-pastMonth"
        name="selectedDate"
        type="radio">
      <label class="filter-option-label"
      for="{{filterName}}-pastMonth">Past month</label>
    </div>

    <div class="filter-option filter-item"
      ngbDropdownItem>
      <input (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-filter-dropdown-option-pastYear'"
        [value]="DateFilterOptions.PASTYEAR"
        formControlName="selectedDate"
        id="{{filterName}}-pastYear"
        name="selectedDate"
        type="radio">
      <label class="filter-option-label"
      for="{{filterName}}-pastYear">Past year</label>
    </div>

    <div class="filter-option filter-item"
      ngbDropdownItem>
      <input #customRange
        (keydown.enter)="closeAndSearch()"
        [attr.data-cy]="filterName + '-filter-dropdown-option-customRange'"
        [value]="DateFilterOptions.CUSTOM"
        formControlName="selectedDate"
        id="{{filterName}}-customRange"
        name="selectedDate"
        type="radio">
      <label class="filter-option-label"
      for="{{filterName}}-customRange">Custom range</label>
    </div>
    <div [hidden]="!customRange.checked"
      [attr.data-cy]="filterName + '-filter-dropdown-range-selection'"
      class="range-selection">
      <div class="text-input">
        <app-input-date #pickDateInputCustomStart
          (inputFocus)="onStartDateFocus()"
          (inputValueChange)="onStartDateChange($event)"
          [alternateBackground]="true"
          [baseCypressTag]="filterName + '-filter-dropdown-option-start-date'"
          [isSmallLabel]="true"
          label="Start"
        placeholder="Pick Date"></app-input-date>
      </div>
      <div class="text-input">
        <app-input-date #pickDateInputCustomEnd
          (inputFocus)="onEndDateFocus()"
          (inputValueChange)="onEndDateChange($event)"
          [alternateBackground]="true"
          [baseCypressTag]="filterName + '-filter-dropdown-option-end-date'"
          [isSmallLabel]="true"
          label="End"
        placeholder="Pick Date"></app-input-date>
      </div>
    </div>

    <app-filter-footer
      (applyClick)="closeAndSearch()"
      (clearClick)="clear()"
    [filterName]="filterName"></app-filter-footer>
  </form>
</div>
